// Generated by purs version 0.15.14
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_LoadDirection from "../Data.LoadDirection/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Additive from "../Data.Monoid.Additive/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Number_Format from "../Data.Number.Format/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var receivedIsSymbol = {
    reflectSymbol: function () {
        return "received";
    }
};
var sentIsSymbol = {
    reflectSymbol: function () {
        return "sent";
    }
};
var lostBytesIsSymbol = {
    reflectSymbol: function () {
        return "lostBytes";
    }
};
var lostPacketsIsSymbol = {
    reflectSymbol: function () {
        return "lostPackets";
    }
};
var totalBytesIsSymbol = {
    reflectSymbol: function () {
        return "totalBytes";
    }
};
var totalPacketsIsSymbol = {
    reflectSymbol: function () {
        return "totalPackets";
    }
};
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt);
var duplicateIsSymbol = {
    reflectSymbol: function () {
        return "duplicate";
    }
};
var outOfOrderIsSymbol = {
    reflectSymbol: function () {
        return "outOfOrder";
    }
};
var totalIsSymbol = {
    reflectSymbol: function () {
        return "total";
    }
};
var semiringRecord = /* #__PURE__ */ Data_Semiring.semiringRecord();
var semiringMaybe = /* #__PURE__ */ Data_Maybe.semiringMaybe(Data_Semiring.semiringInt);
var semiringRecord1 = /* #__PURE__ */ semiringRecord(/* #__PURE__ */ Data_Semiring.semiringRecordCons(receivedIsSymbol)()(/* #__PURE__ */ Data_Semiring.semiringRecordCons(sentIsSymbol)()(Data_Semiring.semiringRecordNil)(/* #__PURE__ */ Data_Maybe.semiringMaybe(/* #__PURE__ */ semiringRecord(/* #__PURE__ */ Data_Semiring.semiringRecordCons(lostBytesIsSymbol)()(/* #__PURE__ */ Data_Semiring.semiringRecordCons(lostPacketsIsSymbol)()(/* #__PURE__ */ Data_Semiring.semiringRecordCons(totalBytesIsSymbol)()(/* #__PURE__ */ Data_Semiring.semiringRecordCons(totalPacketsIsSymbol)()(Data_Semiring.semiringRecordNil)(semiringMaybe))(semiringMaybe))(Data_Semiring.semiringInt))(semiringMaybe)))))(/* #__PURE__ */ Data_Maybe.semiringMaybe(/* #__PURE__ */ semiringRecord(/* #__PURE__ */ Data_Semiring.semiringRecordCons(duplicateIsSymbol)()(/* #__PURE__ */ Data_Semiring.semiringRecordCons(outOfOrderIsSymbol)()(/* #__PURE__ */ Data_Semiring.semiringRecordCons(totalIsSymbol)()(Data_Semiring.semiringRecordNil)(semiringMaybe))(semiringMaybe))(semiringMaybe)))));
var append = /* #__PURE__ */ Data_Semigroup.append(/* #__PURE__ */ Data_Monoid_Additive.semigroupAdditive(semiringRecord1));
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var eqMaybe = /* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqInt);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(totalIsSymbol)(eqMaybe))()(outOfOrderIsSymbol)(eqMaybe))()(duplicateIsSymbol)(eqMaybe))));
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(totalPacketsIsSymbol)(eqMaybe))()(totalBytesIsSymbol)(eqMaybe))()(lostPacketsIsSymbol)(Data_Eq.eqInt))()(lostBytesIsSymbol)(eqMaybe))));
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonInt));
var gEncodeJsonCons1 = /* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonInt));
var gDecodeJsonCons1 = /* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var sub = /* #__PURE__ */ Data_Ring.sub(Data_Ring.ringInt);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Maybe.bindMaybe);
var TransmissionStats = function (x) {
    return x;
};
var showTransmissionStats = /* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(receivedIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(sentIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(lostBytesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(lostPacketsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(totalBytesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(totalPacketsIsSymbol)(showMaybe))(showMaybe))(Data_Show.showInt))(showMaybe)))))(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(duplicateIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(outOfOrderIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(totalIsSymbol)(showMaybe))(showMaybe))(showMaybe)))));
var semiringTransmissionStats = semiringRecord1;
var semigroupTransmissionStat = {
    append: function (v) {
        return function (v1) {
            var v2 = append(v)(v1);
            return v2;
        };
    }
};
var newtypeTransmissionStats_ = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidTransmissionStats = {
    mempty: /* #__PURE__ */ Data_Newtype.un()(Data_Monoid_Additive.Additive)(/* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Monoid_Additive.monoidAdditive(semiringRecord1))),
    Semigroup0: function () {
        return semigroupTransmissionStat;
    }
};
var eqTransmissionStats = {
    eq: function (x) {
        return function (y) {
            return eq(x.received)(y.received) && eq1(x.sent)(y.sent);
        };
    }
};
var encodeJsonTransmissionSta = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons1(totalIsSymbol)())(outOfOrderIsSymbol)())(duplicateIsSymbol)())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons1(totalPacketsIsSymbol)())(totalBytesIsSymbol)())(lostPacketsIsSymbol)())(lostBytesIsSymbol)())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(sentIsSymbol)())(receivedIsSymbol)())();
var decodeJsonTransmissionSta = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1(totalIsSymbol)()())(outOfOrderIsSymbol)()())(duplicateIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1(totalPacketsIsSymbol)()())(totalBytesIsSymbol)()())(lostPacketsIsSymbol)()())(lostBytesIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(sentIsSymbol)()())(receivedIsSymbol)()())();
var subtract = function (v) {
    return function (v1) {
        var subtractSent = function (r1) {
            return function (r2) {
                return {
                    lostPackets: r1.lostPackets - r2.lostPackets | 0,
                    totalPackets: apply(map(sub)(r1.totalPackets))(r2.totalPackets),
                    lostBytes: apply(map(sub)(r1.lostBytes))(r2.lostBytes),
                    totalBytes: apply(map(sub)(r1.totalBytes))(r2.totalBytes)
                };
            };
        };
        var subtractReceived = function (r1) {
            return function (r2) {
                return {
                    outOfOrder: apply(map(sub)(r1.outOfOrder))(r2.outOfOrder),
                    duplicate: apply(map(sub)(r1.duplicate))(r2.duplicate),
                    total: apply(map(sub)(r1.total))(r2.total)
                };
            };
        };
        return {
            sent: apply(map(subtractSent)(v.sent))(v1.sent),
            received: apply(map(subtractReceived)(v.received))(v1.received)
        };
    };
};
var prettyPrintStat = function (v) {
    if (v instanceof Data_Maybe.Nothing) {
        return "NA";
    };
    if (v instanceof Data_Maybe.Just) {
        return Data_Number_Format.toStringWith(Data_Number_Format.precision(2))(v.value0 * 100.0) + "%";
    };
    throw new Error("Failed pattern match at Data.TransmissionStats (line 108, column 3 - line 110, column 73): " + [ v.constructor.name ]);
};
var getPacketLoss = function (v) {
    return bind(v.sent)(function (sent) {
        return bind(map(Data_Int.toNumber)(sent.totalPackets))(function (v1) {
            var lost = Data_Int.toNumber(sent.lostPackets);
            var $261 = v1 === 0.0;
            if ($261) {
                return Data_Maybe.Nothing.value;
            };
            return pure(lost / v1);
        });
    });
};
var getOutOfOrder = function (v) {
    return bind(v.received)(function (received) {
        return bind(map(Data_Int.toNumber)(received.total))(function (v1) {
            return bind(map(Data_Int.toNumber)(received.outOfOrder))(function (v2) {
                var $265 = v1 === 0.0;
                if ($265) {
                    return Data_Maybe.Nothing.value;
                };
                return pure(v2 / v1);
            });
        });
    });
};
var getDuplicate = function (v) {
    return bind(v.received)(function (received) {
        return bind(map(Data_Int.toNumber)(received.total))(function (v1) {
            return bind(map(Data_Int.toNumber)(received.duplicate))(function (v2) {
                var $269 = v1 === 0.0;
                if ($269) {
                    return Data_Maybe.Nothing.value;
                };
                return pure(v2 / v1);
            });
        });
    });
};
var getCombinedStats = function (loadDirection) {
    return function (v) {
        if (loadDirection instanceof Data_LoadDirection.Download) {
            return {
                packetLoss: bindFlipped(getPacketLoss)(v.passive),
                duplicate: bindFlipped(getDuplicate)(v.active),
                outOfOrder: bindFlipped(getOutOfOrder)(v.active)
            };
        };
        if (loadDirection instanceof Data_LoadDirection.Upload) {
            return {
                packetLoss: bindFlipped(getPacketLoss)(v.active),
                duplicate: bindFlipped(getDuplicate)(v.passive),
                outOfOrder: bindFlipped(getOutOfOrder)(v.passive)
            };
        };
        throw new Error("Failed pattern match at Data.TransmissionStats (line 57, column 54 - line 67, column 6): " + [ loadDirection.constructor.name ]);
    };
};
export {
    TransmissionStats,
    getCombinedStats,
    prettyPrintStat,
    subtract,
    newtypeTransmissionStats_,
    semigroupTransmissionStat,
    semiringTransmissionStats,
    monoidTransmissionStats,
    encodeJsonTransmissionSta,
    decodeJsonTransmissionSta,
    showTransmissionStats,
    eqTransmissionStats
};
